
/** params:
 *  - text
 *  - link
 *  - target
 */
export function htmlA(params) {
  return `<a target="${params.target}" style="color: #0066cc; ` +
    `text-decoration:none" href="${params.link}">${params.text}</a>`;
}

export function htmlButton(params) {
  return `<a style="font-family: Roboto, Helvetica, Arial, sans-serif;
                    font-weight: 500;
                    font-size: 0.875rem;
                    text-decoration: none;
                    background-color: #0066cc;
                    color: #fff;
                    padding: 10.8px 24.3px 10.8px 24.3px;
                    border-radius: 5px;
                    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;"
             target="${params.target}"
             href='${params.link}'>
            ${params.text.toUpperCase()}
          </a>`;
}
